module.exports = "/assets/dist/images/bodystyles_vans_sm.png?e95fa1f76e7064c320626b00859f0242";